import { InfoCircleFilled } from '@creditornot/cb-icons';
import { colors } from '@creditornot/cb-ingredients';
import { Tooltip } from '@creditornot/cb-popover';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';
import { GrowthTrend } from 'modules/insights-v2/types';

import Trend from '../Trend';

type Props = {
  title: string;
  tooltip?: string;
  metrics: string | number;
  growth?: string;
  growthTrend?: GrowthTrend;
};

const InfoIcon = styled(InfoCircleFilled).attrs({
  width: 12,
  height: 12,
})`
  fill: ${cssThemedValue({ light: colors.pepper24, dark: colors.salt28 })};
`;
const Header = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
`;
const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const Content = styled.div`
  align-items: baseline;
  display: flex;
  gap: 4px;
`;

const MetricBlock = ({ title, tooltip, metrics, growth, growthTrend }: Props) => (
  <Root>
    <Header>
      <T.Body2>{title}</T.Body2>
      {!!tooltip && (
        <Tooltip content={tooltip}>
          <InfoIcon />
        </Tooltip>
      )}
    </Header>
    <Content>
      <T.Heading6>{metrics}</T.Heading6>
      {growth != null && <Trend trend={growthTrend ?? 'neutral'}>{growth}</Trend>}
    </Content>
  </Root>
);

export default MetricBlock;
